module.exports = __webpack_public_path__ + "static/8889-bf6e65efc4f88a3aa1d0a5f0cff92894.jpg";